import { MomoStatus } from './momoSlice'

// User-facing vocabulary is reduced to FIVE states: Pending / Processing /
// Under Review / Completed / Refunded. Internal stages never leak.
export const MOMO_STATUS_LABEL: Record<MomoStatus, string> = {
  pending: 'Pending',
  awaiting_approval: 'Under Review',
  submitting: 'Processing',
  processing: 'Processing',
  completed: 'Completed',
  manual_review: 'Under Review',
  refunded: 'Refunded',
}

export const MOMO_STATUS_CLASS: Record<MomoStatus, string> = {
  pending: 'bg-yellow-500/15 text-yellow-400',
  awaiting_approval: 'bg-blue-500/15 text-blue-400',
  submitting: 'bg-amber-500/15 text-amber-400',
  processing: 'bg-amber-500/15 text-amber-400',
  completed: 'bg-green-500/15 text-green-400',
  manual_review: 'bg-blue-500/15 text-blue-400',
  refunded: 'bg-gray-500/15 text-gray-300',
}

export const fmtNaira = (n: number) => `₦${Number(n).toLocaleString()}`
export const fmtCedi = (n: number) =>
  `GH₵${Number(n).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`

// Display a Ghana number as 024 123 4567.
export const fmtMsisdn = (m: string) =>
  m && m.length === 10 ? `${m.slice(0, 3)} ${m.slice(3, 6)} ${m.slice(6)}` : m
